import styled, { css } from 'styled-components/macro'

export const RootS = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h3 {
    ${({ theme }) => css(theme.fonts.types.h3)};
  }

  p {
    ${({ theme }) => css(theme.fonts.types.body2)};
  }

  .obs {
    ${({ theme }) => css(theme.fonts.types.caption2)};
  }
`
